import React from "react";
import DeleteIcon from "@material-ui/icons/DeleteOutlined";
import { PopupMessage } from "lego-gui-lib/lib";
import { t } from "../../../core/i18n/i18n";
import { mainStore } from "../../../core/mainStore";
import { RowButton } from "../../../common/RowButtons";

export const deleteButtonWithReload = (reload: () => void) => (
  indexProps: any
) => (row: any, key: string, close: () => void) => {
  const arr = [];
  const commons = mainStore.commons;
  const onDelete = (e: any) => {
    indexProps.setState({ selectedRows: row });
    getPopupMessage();
    close();
  };

  const getPopupMessage = () => {
    const deleteOneTitle = t(
      "lego:views.index.delete.title",
      "Confirm deleting row"
    )();
    const deleteOneContent = t(
      "lego:views.index.delete.content",
      "Are you sure you want to delete selected row?"
    )();
    const dialogMessage: PopupMessage = {
      title: deleteOneTitle,
      content: deleteOneContent
    };
    commons.showDialog(dialogMessage, deleteType);
  };

  const deleteType = () => {
    indexProps
      .delete()
      .then((value: any) => {
        reload();
      })
      .finally(commons.closeDialog());
  };

  arr.push(
    <RowButton
      callbackFunction={onDelete}
      title={["lego:views.index.row.delete", "Delete"]}
      key={key + "delete"}
    >
      <DeleteIcon />
    </RowButton>
  );

  return arr;
};
